{
    "AgentDetails_GUID": "Bezeichner (GUID):",
    "AgentNumber": "Agentennummer:",
    "AgentDetails_Partition": "Teilung:",
    "AgentDetails_Description": "Beschreibung:",
    "AgentDetails_UpdateExistingItems": "Doppelte Einträge aktualisieren:",
    "AgentDetails_GUIDPlaceholder": "[Automatisch zugewiesen]",
    "AgentDetails_Validation_GUID": "Die maximale Länge einer GUID beträgt 100 Zeichen.",
    "AgentDetails_Validation_AgentNumber": "Eine Agentennummer muss angegeben werden",
    "AgentDetails_Validation_Partition": "Eine Partition muss ausgewählt werden",
    "AgentDetails_NonePartition": "[Keine]",
    "NAME": "AgentDetails"
}